<div class="modal-content">
  <h2 class="modal-title">Ajustes en el contrato</h2>
  <p class="body-text">
    Te informamos que hemos realizado algunos ajustes en nuestro contrato de servicios. Estos cambios entran en
    vigencia a partir del 05 de agosto del 2026. Puedes revisar el contrato actualizado en el siguiente enlace:
  </p>

  <a
    [href]="contractUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="contract-link"
  >
    Ver contrato actualizado
  </a>

  <p class="footer-text">
    Al continuar utilizando nuestros servicios, aceptas automáticamente los términos del nuevo contrato.
  </p>

  <button type="button" class="primary-button" (click)="close()">Entendido</button>
</div>
